import { styled } from "@mui/material/styles";
import Menu, { MenuProps } from "@mui/material/Menu";
import MuiAppBar, { AppBarProps } from "@mui/material/AppBar";
import MuiMenuItem, { MenuItemProps } from "@mui/material/MenuItem";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, { AccordionSummaryProps } from "@mui/material/AccordionSummary";
import MuiFormControlLabel, { FormControlLabelProps } from "@mui/material/FormControlLabel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Radio from "@mui/material/Radio";
import colors from "common/styles/colors";

export const AppBar = styled((props: AppBarProps) =>
  <MuiAppBar position="sticky" elevation={0} {...props} />
)({
  "&.MuiPaper-root": {
    backgroundColor: colors.white,
    boxShadow: "0px 2px 6px 0px rgba(0,0,0,0.29)",
    "& .MuiToolbar-root": {
      paddingLeft: "14px",
      paddingRight: "20px",
    }
  }
});

export const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion {...props} disableGutters elevation={0} square children={props.children} />
))({
  border: "none",
  "& .MuiAccordionDetails-root": {
    backgroundColor: colors.white,
    padding: "4px 18px 12px",
  }
});

export const AccordionWithoutGap = styled((props: AccordionProps) => (
  <MuiAccordion {...props} disableGutters elevation={0} square children={props.children} />
))({
  "&$expanded": {
    margin: "auto"
  }
});


export const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={<ExpandMoreIcon />} {...props} />
))({
  "&:hover": {
    backgroundColor: colors.lightGrey2,
  },
  "& span": {
    fontSize: "14px",
    color: colors.primary,
  },
});

export const HeaderMenu = styled((props: MenuProps) =>
  <Menu
    disableScrollLock
    keepMounted={false}
    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    transformOrigin={{ vertical: "top", horizontal: "right" }}
    {...props}
  />
)({
  marginTop: "18px",
  "& .MuiMenu-paper": {
    width: "240px",
    boxShadow: "0 0 4px 1px rgba(0,0,0,0.21)",
    "& .MuiMenu-list": {
      padding: 0,
    },
  }
});

export const MenuItem = styled((props: MenuItemProps) =>
  <MuiMenuItem {...props} />
)({
  padding: "12px",
  minWidth: "150px",
  backgroundColor: colors.white,
  "&:hover": {
    backgroundColor: colors.lightGrey2,
  },
  "& span": {
    fontSize: 14,
    marginLeft: "4px",
    color: colors.primary,
  }
});

export const FormControlLabel = styled((props: Omit<FormControlLabelProps, "control">) =>
  <MuiFormControlLabel {...props} control={<Radio size="small" sx={{ padding: "5px" }} />} />
)({
  marginLeft: "-7px",
  "& .MuiFormControlLabel-label": {
    fontSize: 14,
    color: colors.darkGrey1,
    wordBreak: "break-word",
  },
});
